'use strict';

module.exports = function ($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.tasksAdvanced', {
            url: '/tasksAdvanced',
            templateUrl: 'dashboard-tasks-advanced/dashboard-tasks-advanced.html',
            controller: 'dashboardTasksAdvancedCtrl as ctrl',
            resolve: {},
            data: {
                authorizedRoles: ['admin', 'owner']
            }
        })
        .state('dashboard.departments.department.tasksAdvancedImports', {
            url: '/tasksAdvanced/:departmentId/:mode',
            templateUrl: 'dashboard-tasks-advanced/dashboard-tasks-advanced-imports.html',
            controller: 'dashboardTasksAdvancedImportsCtrl as ctrl',
            resolve: {},
            data: {
                authorizedRoles: ['admin', 'owner']
            }
        })
        .state('dashboard.departments.department.tasksAdvanced.import1', {
            url: '/tasksAdvanced/import1',
            views: {
                'modal-import@': {
                    templateUrl: 'dashboard-tasks-advanced/import/1.html',
                    controller: 'importCtrl1 as ctrl'
                }
            }

        })
        .state('dashboard.departments.department.tasksAdvanced.import2', {
            url: '/tasksAdvanced/import2',
            views: {
                'modal-import@': {
                    templateUrl: 'dashboard-tasks-advanced/import/2.html',
                    controller: 'importCtrl2 as ctrl'
                }
            }

        })
        .state('dashboard.departments.department.tasksAdvanced.import3', {
            url: '/tasksAdvanced/import3',
            views: {
                'modal-import@': {
                    templateUrl: 'dashboard-tasks-advanced/import/3.html',
                    controller: 'importCtrl3 as ctrl'
                }
            }

        });
};
